import styled from 'styled-components';

export const AvatarImage = styled.img<{ objectFit?: string }>`
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: ${({ objectFit }) => objectFit ?? 'cover'};
`;
